import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { OpenStatus } from "./OpenStatus";

const links = [
  { to: "/", label: "Home" },
  { to: "/occasions", label: "Occasions" },
  { to: "/werkplaats", label: "Werkplaats" },
  { to: "/avia", label: "AVIA" },
  { to: "/over-ons", label: "Over ons" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-white/70 border-b border-black/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <Link to="/" data-testid="logo-link" className="flex items-center group">
          <img src={`${process.env.PUBLIC_URL}/stoof-logo.png`} alt="Automobielbedrijf Stoof — Vinkeveen" className="h-10 w-auto transition-transform group-hover:scale-[1.03]" />
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm font-semibold transition-colors relative group ${
                loc.pathname === l.to ? "text-primary" : "text-text-main hover:text-primary"
              }`}
            >
              {l.label}
              <span className="absolute -bottom-1.5 left-0 h-[2px] bg-primary transition-all duration-300 w-0 group-hover:w-full" />
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <OpenStatus className="hidden lg:inline-flex" />
          <Link
            to="/contact"
            data-testid="nav-cta-proefrit"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-primary text-white text-sm font-semibold px-5 py-2.5 hover:bg-primary-light transition-colors group"
          >
            Proefrit inplannen
            <span className="transition-transform group-hover:translate-x-1">→</span>
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 text-text-main"
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-border px-6 py-4 flex flex-col gap-1">
          <div className="py-2"><OpenStatus /></div>
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-lg font-semibold py-3 border-b border-black/5 ${
                loc.pathname === l.to ? "text-primary" : "text-text-main"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/contact" data-testid="mobile-nav-cta-proefrit" className="mt-4 rounded-full bg-primary text-white text-center font-semibold px-5 py-3.5">
            Proefrit inplannen
          </Link>
        </div>
      )}
    </header>
  );
};
